import { ArrowRight, Smartphone } from "lucide-react";
import { Link } from "react-router-dom";
import { useTranslation } from "@/components/LanguageContext";

const HERO_IMG = "https://customer-assets.emergentagent.com/job_wp-landing-builder/artifacts/am28st5f_image.png";

export default function HeroSection() {
  const { t } = useTranslation();

  return (
    <section
      data-testid="hero-section"
      className="hero-fullscreen relative w-full overflow-hidden"
      style={{ height: "100vh", minHeight: "600px" }}
    >
      <div className="absolute inset-0 hero-bg-zoom">
        <img src={HERO_IMG} alt="Aircraft engine turbine" className="w-full h-full object-cover object-center" loading="eager" fetchPriority="high" data-testid="hero-image" style={{ willChange: "transform" }} />
      </div>
      <div className="absolute inset-0 bg-gradient-to-r from-[#020518]/85 via-[#0A1628]/60 to-transparent" />
      <div className="absolute inset-0 bg-gradient-to-t from-[#020518]/50 via-transparent to-[#020518]/20" />

      <div className="relative z-10 h-full flex items-center">
        <div className="max-w-7xl mx-auto px-6 md:px-12 w-full pt-[100px]">
          <div className="max-w-2xl animate-fade-in-up">
            <div className="inline-flex items-center gap-2 bg-white/10 backdrop-blur-sm border border-white/15 rounded-full px-4 py-2 mb-8">
              <span className="w-2 h-2 rounded-full bg-[#00A8FF] animate-pulse" />
              <span className="text-xs font-semibold uppercase tracking-[0.15em] text-white/90">
                {t("hero.badge")}
              </span>
            </div>

            <h1 className="font-['Outfit'] text-5xl sm:text-6xl lg:text-7xl font-black tracking-tight leading-[1.02] text-white mb-6">
              {t("hero.title1")}{" "}
              <span className="relative inline-block">
                <span className="bg-gradient-to-r from-[#F59E0B] via-[#FBBF24] to-[#F59E0B] bg-clip-text text-transparent">
                  {t("hero.titleFuturo")}
                </span>
                <span className="absolute -bottom-1 left-0 w-full h-1 bg-gradient-to-r from-[#00A8FF] to-[#F59E0B] rounded-full" />
              </span>
              {" "}{t("hero.titleNa")}{" "}
              <span className="bg-gradient-to-r from-[#00A8FF] via-[#3BC4FF] to-[#00A8FF] bg-clip-text text-transparent">
                {t("hero.titleAviacao")}
              </span>
            </h1>

            <p className="text-base md:text-lg text-white/75 mb-10 max-w-xl leading-relaxed">
              {t("hero.desc")}
            </p>

            <div className="flex flex-wrap gap-4">
              <a href="/#exames" className="btn-primary-gold py-3.5 px-8 rounded-md inline-flex items-center gap-2 text-sm" data-testid="hero-cta-primary">
                {t("hero.ctaPrimary")}
                <ArrowRight className="w-4 h-4" />
              </a>
              <Link to="/app#app-demo" className="animate-pulse-glow bg-white/10 backdrop-blur-sm hover:bg-white/20 text-white font-bold py-3.5 px-8 rounded-md border border-white/20 inline-flex items-center gap-2 text-sm transition-all duration-300" data-testid="hero-cta-secondary">
                <Smartphone className="w-4 h-4" />
                {t("hero.ctaSecondary")}
              </Link>
            </div>

            <div className="mt-14 flex items-center gap-10">
              {[
                { val: "17", label: t("hero.statModules") },
                { val: "10000+", label: t("hero.statQuestions") },
                { val: "100%", label: t("hero.statMobile") },
              ].map((stat, i) => (
                <div key={i} className="flex items-center gap-10">
                  {i > 0 && <div className="w-px h-10 bg-white/20 -ml-10" />}
                  <div>
                    <p className="font-['Outfit'] text-3xl font-black text-white">{stat.val}</p>
                    <p className="text-xs text-white/50 font-medium mt-0.5">{stat.label}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
      <div className="absolute bottom-0 left-0 right-0 h-24 bg-gradient-to-t from-white to-transparent" />
    </section>
  );
}
